var $ = require('jquery');

/**
 * Socail share mechanism
 */
    var SocialShare = module.exports = function(){
        var t = this;
    };
    SocialShare.prototype = {
        init: function(){
            var t = this;
            t._setSocialMethods();
            t._bindEvents();
        },

        _setSocialMethods: function(){
            var t = this;

            t.methods = t.methods || {};

            t.methods['facebook'] = function($elm, e){
                window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(document.URL) + '&amp;t=' + encodeURIComponent(document.title) + '', 'facebook', 'width=620, height=440, resizable=no,scrollbars=0');
            };

            t.methods['twitter'] = function($elm, e){
                window.open('http://twitter.com/share?text=' + encodeURIComponent(document.title) + '', 'twitter', 'width=620, height=440, resizable=no,scrollbars=0');
            };

            t.methods['mail'] = function($elm, e){
                hs.htmlExpand(null, {src: "/qf/en/ramjet/share-form", wrapperClassName: 'no-header', objectType: 'iframe', width: 600, height: 650 }, { disableKeys : true });
            };

            t.methods['email'] = function($elm, e){
                t.methods['mail']($elm, e);
            };
        },

        getMethod: function(methodName) {
            var t = this;

            return t.methods[methodName] || null;
        },

        _bindEvents: function(){
            var t = this;

            $("body").on("click", ".js_socialShare", function(e){
                var $elm = $(this);


                var method = t.getMethod(t._getSocialType($elm));

                if (method != null) {
                    method($elm, e);
                }

                e.preventDefault();
            })
        },

        _getSocialType: function($elm){
            var t = this;

            return $elm.data("socialShareType") || "null";
        }

    }


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/SocialShare.js